import { useStaticQuery, graphql } from 'gatsby';

export const useFooter = () => {
	const { links, locations } = useStaticQuery(
		graphql`
			query Footer {
				links: allDatoCmsFooterLink(
					sort: { position: ASC }
					filter: { name: { ne: "Supplier Early Payments" } }
				) {
					nodes {
						link
						name
						column
					}
				}
				locations: allDatoCmsLocation(sort: { position: ASC }) {
					nodes {
						addressLine1
						addressLine2
						addressLine3
					}
				}
			}
		`
	);

	return { footerLinks: links.nodes, locations: locations.nodes };
};
